<template>
  <transition name="modal">
    <div class="modal-mask" @click="close" :class="{ 'is-height-limited': isHeightLimited }">
      <div class="modal-wrapper">
        <div class="modal-container container" @click.stop="bubbleParams || true">
          <div class="header" v-if="showHeader">
            <slot name="header"></slot>
          </div>
          <div class="body">
            <slot name="body"></slot>
          </div>
          <div class="footer" v-if="showFooter">
            <slot name="footer"><button class="default-button" type="button" @click="close">OK</button></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const data = function() {
  return {
    savedScrollY: 0,
  };
};

const props = {
  showHeader: {
    type: Boolean,
    default: false,
  },
  showFooter: {
    type: Boolean,
    default: false,
  },
  show: {
    type: Boolean,
    default: false,
  },
  bubbleParams: {
    type: Boolean,
    default: true,
  },
  isHeightLimited: {
    type: Boolean,
    default: false,
  },
};

function getListener(e) {
  if (this.show && e.keyCode === 27) {
    this.close();
  }
}

const mounted = function() {
  document.addEventListener('keydown', this.getListener);
  this.lockBodyScroll();
};

const destroyed = function() {
  document.removeEventListener('keydown', this.getListener);
  this.unlockBodyScroll();
};

const methods = {
  close() {
    this.$emit('close');
  },
  getListener,
  lockBodyScroll() {
    this.savedScrollY = window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = `-${this.savedScrollY}px`;
    document.body.style.left = 0;
    document.body.style.right = 0;
    document.body.style.bottom = 0;
  },
  unlockBodyScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.bottom = '';
    window.scrollTo(0, this.savedScrollY);
  },
};

export default {
  name: 'Modal',
  data,
  props,
  mounted,
  destroyed,
  methods,
};
</script>

<style lang="scss" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-mask.is-height-limited {
  display: flex;
  align-items: center;
  justify-content: center;

  .modal-wrapper {
    display: block;
    height: 72%;
    width: 100%;
    overflow: hidden;
  }

  .modal-container {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .header,
  .footer {
    flex: 0;
  }

  .body {
    overflow-y: scroll;
  }

  @media (min-width: 991px) {
    .modal-wrapper {
      height: 100%;
    }
    .modal-container {
      max-width: 100%;
    }
  }

  @media (min-width: 1280px) {
    .modal-container {
      max-width: 1280px;
    }
  }
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}

.header h3 {
  margin-top: 0;
  color: #42b983;
}

.body {
  margin: 20px 0;
}

.default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
